import { IoServer } from "@onemind-services-llc/react-icons-ng/io5";
import { FaHandsHelping } from "@onemind-services-llc/react-icons-ng/fa";
import { MdOutlineTapAndPlay } from "@onemind-services-llc/react-icons-ng/md";
import {
  RiFolderCloudFill,
  RiPrinterCloudFill,
} from "@onemind-services-llc/react-icons-ng/ri";
import { SiSpringsecurity } from "@onemind-services-llc/react-icons-ng/si";
import { ContentCard } from "@/components/contentCard";
import { MAIN_ROUTES } from "@/constants/routes";

export const NAVIGATION_CARDS_CONSTANTS = {
  list: [
    {
      icon: IoServer,
      title: "Public Cloud (IaaS)",
      content: (
        <ContentCard
          link={{ pathname: MAIN_ROUTES.CLOUD_SERVICES, query: { tab: "0" } }}
          points={[
            "Dedicated Servers ",
            "Bare-Metal Server",
            "Cloud GPU ",
            "Block storage | S3 Storage",
            "Load Balancers",
            "Public IPv4 | IPv6",
            "Kubernetes",
            "Platform as a Service (PaaS)",
            "Virtual Desktop Infrastructure (VDI)",
            "Managed Microsoft 365",
          ]}
        />
      ),
    },
    {
      icon: RiPrinterCloudFill,
      // image: csp,
      title: "Private Cloud",
      content: (
        <ContentCard
          link={{ pathname: MAIN_ROUTES.CLOUD_SERVICES, query: { tab: "1" } }}
          points={[
            "Zadara Cloud",
            "OEM Converged Architecture",
            "Private K8 Clusters",
            "OneMind's Managed Open Stack(MOST)",
            "Encrypted Storage Clusters",
            "VDI on Private Cloud",
          ]}
        />
      ),
    },
    {
      icon: RiFolderCloudFill,
      title: "POC Cloud",
      content: (
        <ContentCard
          link={{ pathname: MAIN_ROUTES.CLOUD_SERVICES, query: { tab: "2" } }}
          points={[
            "Lab-as-a-service",
            "POC-as a service",
            "Network Digital Twins",
            "Certification Labs",
            "Physical Labs (SI | VAR|COE)",
            "Network Automation",
            "Performance Labs | OEM Test Labs",
            "Emulate | Simulate | Real",
          ]}
        />
      ),
    },
    {
      icon: SiSpringsecurity,
      title: " Security Services",
      content: (
        <ContentCard
          link={MAIN_ROUTES.SECURITY_SERVICES}
          points={[
            "EDR | MDR | XDR",
            "Ransomware and DDOS Protection",
            "ZTNA | VPN | Edge Firewall | SASE",
            "Vulnerability and Patch Management",
            "Compliance Management | SEC OPS",
            "Cloud security Posture Management",
            "Security Assessments / Pen Testing",
          ]}
        />
      ),
    },
    {
      icon: MdOutlineTapAndPlay,
      title: "Network Services",
      content: (
        <ContentCard
          link={MAIN_ROUTES.NETWORK_SERVICES}
          points={[
            "Cloud Migration",
            "Internet and DCI",
            "SDN | SD-WAN ",
            " Unified Communication",
            "Wired and Wireless Infra",
            "Network Design and Deployment",
            "NMS | Observability | Custom Netbox",
            "Manged Colocation",
            "NOC | SOC | Helpdesk",
          ]}
        />
      ),
    },
    {
      icon: FaHandsHelping,
      title: "Application Services",
      content: (
        <ContentCard
          link={MAIN_ROUTES.APPLICATION_SERVICES}
          points={[
            "Hosted Elastic Stack Licensed",
            "Hosted Grafana",
            "Hosted OpenText NOM",
            "Hosted Yeastar PBX",
            "Hosted NetBox (IPAM/DCIM)",
            "Inuvika VDI Platform (Linux/Windows)",
            "Hosted Mac   ",
            "Marketplace Apps",
          ]}
        />
      ),
    },
  ],
  hoverEffect: true,
};
